import React from 'react'

import CartLoader from '../Cart/Cart.loader'
import MenuPageLayout from './MenuPageLayout/MenuPageLayout'
import MenusLoader from '../Menus/Menus.loader'
import RestaurantHeaderLoader from '../RestaurantHeader/RestaurantHeader.loader'
import { useLoadTimer } from '../ReactGAUtils/ReactGAUtils'

import './MenuPage.css'

const MenuPageLoader = () => {
  useLoadTimer({ category: 'Menu Page' })
  return (
    <MenuPageLayout
      header={<RestaurantHeaderLoader />}
      menus={<MenusLoader />}
      cart={<CartLoader />}
    />
  )
}

export default MenuPageLoader
